class FarloUiTicketCalendar {
    constructor(element, _config) {
        this.container = element;
        this.options = _config;
        this.minDate = new Date(this.container.dataset.startMonth);
        this.maxDate = new Date(this.container.dataset.endMonth);
        if (this.container.dataset && this.container.dataset.startMonth) {
            this.currentDate = new Date(this.container.dataset.startMonth);
        } else {
            this.currentDate = new Date();
        }
        this.render();
    }


    padString(value,type) {
        if (type === "time") {
            if (value.length == 1 || value === 0) {
                return (value + "0").toString();
            }
        } else {
            if (value < 10) {
                return "0" + value;
            }
        }
        return value;
    }
    addParts(name) {
        if (name.match(/^Part /i)) {
            return " - " + name;
        }
        return "";
    }


    renderHeader() {
        const header = document.createElement('div');
        header.classList.add('farlo-ui-ticket-calendar__header');
    
        const prevButton = document.createElement('button');
        prevButton.classList.add('farlo-ui-ticket-calendar__button', 'farlo-ui-ticket-calendar__button--prev', 'button');
        prevButton.innerHTML = '&#10094;';
    
        if (parseInt(this.currentDate.getFullYear().toString() + this.padString(this.currentDate.getMonth()), 10) >
        parseInt(this.minDate.getFullYear().toString() + this.padString(this.minDate.getMonth()), 10)) {
            prevButton.classList.remove('farlo-ui-ticket-calendar__button-disabled');
            prevButton.addEventListener('click', () => this.prevMonth());
        } else {
            prevButton.classList.add('farlo-ui-ticket-calendar__button-disabled');
        }
    
        const title = document.createElement('h4');
        title.classList.add('farlo-ui-ticket-calendar__header-month-year');
        title.textContent = this.currentDate.toLocaleDateString(undefined, { year: 'numeric', month: 'long' });
    
        const nextButton = document.createElement('button');
        nextButton.classList.add('farlo-ui-ticket-calendar__button', 'farlo-ui-ticket-calendar__button--next', 'button');
        nextButton.innerHTML = '&#10095;';
    
        if (parseInt(this.currentDate.getFullYear().toString() + this.padString(this.currentDate.getMonth()), 10) <
            parseInt(this.maxDate.getFullYear().toString() + this.padString(this.maxDate.getMonth()), 10)) {
            nextButton.classList.remove('farlo-ui-ticket-calendar__button-disabled');
            nextButton.addEventListener('click', () => this.nextMonth());
        } else {
            nextButton.classList.add('farlo-ui-ticket-calendar__button-disabled');
        }
    
        header.appendChild(prevButton);
        header.appendChild(title);
        header.appendChild(nextButton);
    
        this.container.appendChild(header);
        this.renderAvailabilityKey();
    }
    
    renderAvailabilityKey() {
        const availabilityKey = document.createElement('div');
        availabilityKey.classList.add('farlo-ui-ticket-calendar__availability-key');
    
        const keys = [
            { label: 'Sold Out', class: 'sold-out' },
            { label: 'Last Few', class: 'last-few-tickets' },
            { label: 'Selling Fast', class: 'selling-fast' },
            { label: 'Available', class: 'available-tickets' },
        ];
    
        keys.forEach(key => {
            const keyItem = document.createElement('div');
            keyItem.classList.add('farlo-ui-ticket-calendar__key-item', key.class);
            keyItem.textContent = key.label;
            availabilityKey.appendChild(keyItem);
        });
    
        this.container.appendChild(availabilityKey);
    }
    

    renderDaysOfTheWeeks() {
        const div = document.createElement('div');
        div.classList.add('farlo-ui-ticket-calendar__weeks');
        const daysLetters = ['S<span>un</span>','M<span>on</span>', 'T<span>ue</span>', 'W<span>ed</span>', 'T<span>hu</span>', 'F<span>ri</span>', 'S<span>at</span>'];

        for (let i = 0; i < 7; i += 1) {
            const days = document.createElement('div');
            days.classList.add('farlo-ui-ticket-calendar__week-day');
            days.innerHTML = daysLetters[i];
            div.appendChild(days);
        }

        this.container.appendChild(div);
    }

    getUKDay(date) {
        let day = date.getDay();
        return day === 0 ? 6 : day - 1;
    }
    getUSDay(date) {
        return date.getDay();
    }

    generateBookingURL(_perf) {
        return _farloCalendarConfig.booking_hostname + "/" + _perf.production_season_id + "/" + _perf.performance_id + "/";
    }

    renderDaysInMonth() {
        const daysContainer = document.createElement('div');
        daysContainer.classList.add('farlo-ui-ticket-calendar__days');
    
        const year = this.currentDate.getFullYear();
        const month = this.currentDate.getMonth();
    
        const firstDay = this.getUSDay(new Date(year, month, 1));
        const daysInMonth = new Date(year, month + 1, 0).getDate();
    
        let elementCount = 0;

        for (let i = 0; i < firstDay; i++) {
            elementCount++;
            const blankDay = document.createElement('div');
            blankDay.classList.add('farlo-ui-ticket-calendar__day', 'farlo-ui-ticket-calendar__day--empty');
            daysContainer.appendChild(blankDay);
        }
    
        for (let day = 1; day <= daysInMonth; day++) {
            elementCount++;
            const dayElement = document.createElement('div');
            dayElement.classList.add('farlo-ui-ticket-calendar__day');
            
            const dayNumber = document.createElement('div');
            dayNumber.classList.add('farlo-ui-ticket-calendar__day-number');
            dayNumber.textContent = day;

            const eventDate = new Date(Date.UTC(year, month, day)).toISOString().split('T')[0];
            const eventsOnThisDay = _farloCalendarConfig.performanceData.filter(event => event.start_date_time.startsWith(eventDate));

            dayElement.appendChild(dayNumber);

            let hasAvailability = false;
            if (eventsOnThisDay.length > 0) {
                eventsOnThisDay.forEach(event => {
                    const eventElement = document.createElement('a');
                    eventElement.classList.add('farlo-ui-ticket-calendar__event');
                    eventElement.addEventListener("click", (e)=> {
                        if (window.innerWidth < 980) {
                            e.preventDefault();
                        }
                    })
                    const eventInfo = document.createElement('div');
                    eventInfo.classList.add('farlo-ui-ticket-calendar__event-info');
    
                    const availability = parseInt(event.availability);
                    let availabilityClass = '';
                    if (availability === 0) {
                        availabilityClass = 'sold-out';
                    } else {
                        hasAvailability = true;
                        if (availability < _farloCalendarConfig.last_few) {
                            availabilityClass = 'last-few-tickets';
                        } else if (availability < _farloCalendarConfig.selling_fast) {
                            availabilityClass = 'selling-fast';
                        } else {
                            availabilityClass = 'available-tickets';
                        }
                        eventElement.href = this.generateBookingURL(event);
                    }

                    eventInfo.innerHTML = `<span class="farlo-ui-ticket-calendar__event-link farlo-ui-ticket-calendar__event-link-${availabilityClass}"><span>${this.performanceTime(event)}</span></span>`;
                    eventElement.classList.add(availabilityClass);
                    eventElement.appendChild(eventInfo);
                    dayElement.appendChild(eventElement);

                });
                if (hasAvailability) {
                    dayElement.addEventListener("click",() => {
                        if (window.innerWidth < 980) {
                            this.populatePerformances(dayElement, eventDate)
                        }
                    })
                }
            } else {
                dayElement.classList.add("farlo-ui-ticket-calendar__day--empty");

            }
    
            daysContainer.appendChild(dayElement);
            if (elementCount % 7 === 0) {
                const calendarGap = document.createElement("div");
                calendarGap.classList.add("farlo-ui-ticket-calendar__gap");
                daysContainer.append(calendarGap);
            }
        }
        const calendarGap = document.createElement("div");
        calendarGap.classList.add("farlo-ui-ticket-calendar__gap");
        daysContainer.append(calendarGap);
        this.container.appendChild(daysContainer);
    }
    
    performanceTime(_perf) {
        const dtPerformance = new Date(_perf.start_date_time);
        if (_farloCalendarConfig.time_format == 12) {
            let ampm = "a";
            const hour = dtPerformance.getHours();
            if (hour > 12) {
                ampm = "p";
            }
            return (hour%12) + ":" + this.padString(dtPerformance.getMinutes(),"time") + ampm;

        } else {
            return dtPerformance.getHours() + ":" + this.padString(dtPerformance.getMinutes(),"time")
        }

    }

    populatePerformances(_sel, eventDate) {
        this.container.querySelectorAll(".farlo-ui-ticket-calendar__day").forEach(_day => {
            _day.classList.remove("farlo-ui-ticket-calendar__day-active");
        });
        _sel.classList.add("farlo-ui-ticket-calendar__day-active");

        this.container.querySelectorAll(".farlo-ui-ticket-calendar__gap").forEach(_gap => {
            _gap.innerHTML = "";
            _gap.classList.remove("farlo-ui-ticket-calendar__gap-active");
        })
        const nextTarget = this.getNextElementByClass(_sel, 'farlo-ui-ticket-calendar__gap');
        nextTarget.classList.add("farlo-ui-ticket-calendar__gap-active");
        const eventsOnThisDay = _farloCalendarConfig.performanceData.filter(event => event.start_date_time.startsWith(eventDate));
        eventsOnThisDay.forEach(_perf => {
            const performanceElement = document.createElement("a");
            performanceElement.href = this.generateBookingURL(_perf);
            
            let availabilityClass = '';
            if (_perf.availability === 0) {
                availabilityClass = 'sold-out';
            } else {
                if (_perf.availability < _farloCalendarConfig.last_few) {
                    availabilityClass = 'last-few-tickets';
                } else if (_perf.availability < _farloCalendarConfig.selling_fast) {
                    availabilityClass = 'selling-fast';
                } else {
                    availabilityClass = 'available-tickets';
                }
            }
            performanceElement.classList.add("farlo-ui-ticket-calendar__perf", availabilityClass);

            const dtPerformance = new Date(_perf.start_date_time);

            const performanceDate = document.createElement("div");
            performanceDate.innerHTML = dtPerformance.getDate();
            performanceDate.classList.add("farlo-ui-ticket-calendar__perf-date");
            
            const performanceDay = document.createElement("div");
            performanceDay.innerHTML = _farloCalendarConfig.day_names[dtPerformance.getDay()];
            performanceDay.classList.add("farlo-ui-ticket-calendar__perf-day");

            const performanceTime = document.createElement("div");
            performanceTime.innerHTML = this.performanceTime(_perf);
            performanceTime.classList.add("farlo-ui-ticket-calendar__perf-time");

            const performancePrice =  document.createElement("div");
            performancePrice.innerHTML = "From " + _farlo.helpers.strings.toCurrency(_perf.min_price)
            performancePrice.classList.add("farlo-ui-ticket-calendar__perf-price");

            const performanceButton = document.createElement("div");
            performanceButton.innerHTML = "Book Now";
            performanceButton.classList.add("farlo-ui-ticket-calendar__perf-button", "button", "button--outline", "wp-block-button__link", "is-style-small");

            const performanceLeft = document.createElement("div");
            performanceLeft.classList.add("farlo-ui-ticket-calendar__perf-left");
            performanceLeft.appendChild(performanceDate);
            performanceLeft.appendChild(performanceDay);

            const performanceRight = document.createElement("div");
            performanceRight.classList.add("farlo-ui-ticket-calendar__perf-right");
            performanceRight.appendChild(performanceTime);
            performanceRight.appendChild(performancePrice);


            const performanceControl = document.createElement("div");
            performanceControl.classList.add("farlo-ui-ticket-calendar__perf-control");
            performanceControl.append(performanceButton);
            
            performanceElement.appendChild(performanceLeft);
            performanceElement.appendChild(performanceRight);
            performanceElement.appendChild(performanceControl);

            nextTarget.appendChild(performanceElement);
        })
    }

    getNextElementByClass(startElement, targetClass) {
        let nextElement = startElement.nextElementSibling;
        
        while (nextElement) {
            if (nextElement.classList.contains(targetClass)) {
                return nextElement;
            }
            nextElement = nextElement.nextElementSibling;
        }
        
        return null;
    }

    async fetchEventsForMonth(y, m) {
        // Clear the container before adding new content
        this.container.innerHTML = '';
        this.renderHeader();
        this.renderDaysOfTheWeeks();
        this.renderDaysInMonth();
    }

    async render() {
        this.container.innerHTML = '';
        this.renderHeader();
        this.renderDaysOfTheWeeks();
        this.renderDaysInMonth();
    }

    prevMonth() {
        this.currentDate.setMonth(this.currentDate.getMonth() - 1);
        this.render();
    }

    nextMonth() {
        this.currentDate.setMonth(this.currentDate.getMonth() + 1);
        this.render();
    }

    handleEventClick(event) {
        if (this.options.eventClick) {
            this.options.eventClick(event);
        }
    }
}

export default FarloUiTicketCalendar;
